import { themes } from "./themes";
const app_theme: string = process.env.REACT_APP_THEME
  ? process.env.REACT_APP_THEME
  : "standard";

//Neutrals
export const white = "#FFFFFF";
export const white_00 = "#FFFFFF";
export const white_01 = "#FAFAFA";
export const off_white = "#FCFDFD";

export const gray = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#475467";
export const gray_01 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#E4E7EC";
export const gray_100 = "#F9FAFB";
export const gray_200 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#e4e7ec";
export const gray_400 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#98a2b3";
export const gray_500 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#667085";
export const gray_600 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#475467";

export const black = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#101828";
export const black_01 = themes?.[app_theme]
  ? themes[app_theme]?.primary_color
  : "#1F2631";
export const black_02 = "#151A1D";
export const black_03 = "#404B50";
export const black_800 = "#1d2939";

// Primary
export const yellow = "#fdd835";
export const blue = "#2196F3";
export const light_blue = "#5B8CFD";
export const sheer_blue = "#CCDBFF";
export const green = "#59E1C9";
export const green_teal = "#9CC1CC";
export const dark_green = "#00b186";
export const light_green = "#A8F9EA";
export const light_purple = "#7b73e4";
export const lilac = "#93ABFF";
export const purple = "#F1F2FB";
export const purple_300 = "#A0A3F2";
export const dark_purple = "#8280C7";
export const red = "#FD0379";
export const dark_red = "#FA2238";
export const orange = "#FFA32C";
export const teal = "#1e4854";
export const teal_50 = "#DBF2FC";
export const magenta = "#F21D6B";

export const info_blue = "#0b5cd7";

export const main_box_shadow = "0px 0px 25px 0px rgba(63, 106, 194, 0.15)";
export const box_shadow_override = "0px 0px 0px 0px #FFFFFF";

// Gradients
export const gradient_01 = themes?.[app_theme]
  ? themes?.[app_theme].primary_gradient
  : "linear-gradient(90.06deg, #DBF2FC 0.06%, #E8E8FF 51.56%, #FFF4E3 99.94%)";
